<template>
    <div class="w-full px-12 mt-48 xs:w-1/2 sm:w-1/3">
        <!--CARD START-->
        <div>
            <div class="flex items-center">
                <div class="flex items-center justify-center flex-shrink-0 w-48 h-48 bg-yellow-200 rounded-full">
                    <div class="flex-shrink-0 block w-24 h-24 fill-current text-primary">
                        <IconNotesSVG class="w-24 h-24" />
                    </div>
                </div>

                <span class="ml-12 font-normal title-lg text-primary">{{ $t('info.subsidiaries') }}</span>
            </div>
            <span
                v-for="parent in customerInfo.parent_companies"
                :key="parent.customer_id"
                class="block mt-16 text-base font-semibold sm:text-md"
                >{{ parent.name }}</span
            >
            <span
                v-for="subsidiary in customerInfo.subsidiaries"
                :key="subsidiary.customer_id"
                class="block mt-16 text-base font-semibold sm:text-md"
                >{{ subsidiary.name }}</span
            >
            <!--TODO: hidden  atm - who can edit?-->
            <button hidden v-if="customerInfo.customertype === 'P'" class="mt-16 self-btn-plain" @click="openModal('group_orgs')">
                <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                    <IconPencilSVG />
                </span>
                <span class="self-btn-plain__text">{{ $t('info.modify') }}</span>
            </button>
        </div>
        <!--                            CARD END-->
        <!--    MODAL START-->
        <div class="micromodal" id="group_orgs" aria-hidden="true">
            <div class="px-10 micromodal__overlay" tabindex="-1">
                <div class="micromodal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                    <header class="micromodal__header">
                        <h2 class="pb-24 pr-48 title-2xl text-primary">{{ $t('info.edit_subsidiaries') }}</h2>

                        <button class="micromodal__close" aria-label="Close modal" data-micromodal-close>
                            <span class="flex-shrink-0 block w-20 h-20 text-black pointer-events-none fill-current">
                                <IconXSVG />
                            </span>
                        </button>
                    </header>
                    <div class="micromodal__content">
                        <div class="flex self-form-wrap">
                            <div class="w-full self-form-wrap-item">
                                <label class="e5-form-label" for="nimi"
                                    >{{ $t('info.company_name') }}
                                    <span class="e5-form-field-required">({{ $t('info.required') }})</span></label
                                >
                                <div class="relative">
                                    <input type="text" id="nimi" placeholder="" name="nimi" value="" class="e5-input" />
                                </div>
                            </div>

                            <div class="flex items-center justify-between w-full px-8 pt-16">
                                <div>
                                    <button class="self-btn-primary">
                                        {{ $t('info.save') }}

                                        <span class="text-yellow-300 self-btn-primary__icon">
                                            <IconArrowAltSVG />
                                        </span>
                                    </button>
                                </div>

                                <div>
                                    <button data-micromodal-close="" class="self-btn-plain">
                                        <span class="w-16 ml-0 mr-4 self-btn-plain__icon">
                                            <IconXSVG />
                                        </span>
                                        <span class="self-btn-plain__text">{{ $t('info.cancel') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--    MODAL END-->
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { ICustomer } from '@/domain/ICustomer';
import IconPencilSVG from '@/assets/static/icons-src/icon-pencil.svg';
import IconNotesSVG from '@/assets/static/icons-src/icon-notes.svg';
import IconXSVG from '@/assets/static/icons-src/icon-x.svg';
import IconArrowAltSVG from '@/assets/static/icons-src/icon-arrow-alt.svg';
import UtilsMixin from '@/scripts/utils';

@Component({
    components: {
        IconPencilSVG,
        IconNotesSVG,
        IconXSVG,
        IconArrowAltSVG
    },
    mixins: [UtilsMixin]
})
export default class GroupHierarchy extends Vue {
    get customerInfo(): ICustomer {
        return this.$store.getters.getCustomerInfo;
    }
}
</script>

<style scoped></style>
